import React, { useState, useContext } from "react";
import { Form, Input, Button, Typography, message, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { axiosForm } from "../../axiosInstances";
import { AuthContext } from "./AuthContext";
import Logo from "../common/Logo";
import AnimatedBackground from "./AnimatedBackground";

const { Title } = Typography;

const LoginForm = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await axiosForm.post("/authentication/token/", {
        username: values.email,
        password: values.password,
      });
      // Handle must change password
      if (response.data.require_password_change) {
        message.warning("Veuillez changer votre mot de passe avant de continuer.");
        navigate("/change-password", { state: { username: values.email, password: values.password } });
        return;
      }
      login(response.data.access, response.data.refresh);
      message.success("Connexion réussie !");
      navigate("/dashboard");
    } catch (error) {
      // Handle must change password error from backend (if sent as error)
      if (error.response?.data?.require_password_change) {
        message.warning("Veuillez changer votre mot de passe avant de continuer.");
        navigate("/change-password", { state: { username: values.email, password: values.password } });
        return;
      }
      message.error(
        error.response?.data?.detail ||
          "Échec de la connexion. Vérifiez vos identifiants."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
        position: "relative"
      }}
    >
      <AnimatedBackground />
      <Card
        style={{
          maxWidth: 400,
          width: "100%",
          padding: 24,
          borderRadius: 12,
          boxShadow: "0 2px 16px #0002",
          zIndex: 1,
          background: "#fff",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <Logo size={300} />
        </div>
        <Title level={3} style={{ textAlign: "center" }}>
          Connexion
        </Title>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Adresse email"
            name="email"
            rules={[
              { required: true, message: "Veuillez saisir votre adresse email" },
              { type: "email", message: "L'email n'est pas valide" },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Mot de passe"
            name="password"
            rules={[{ required: true, message: "Veuillez saisir votre mot de passe" }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{ marginTop: 8 }}
            >
              Se connecter
            </Button>
          </Form.Item>
          <div style={{ textAlign: "center" }}>
            Pas de compte ?{" "}
            <a href="/register">Créer un compte</a>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default LoginForm;
